import { ModuleWithProviders, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule as HttpClientNativeModule } from '@angular/common/http';

import { HttpClientErrorInterceptor } from './interceptors/http-client-error.interceptor';
import { HttpClientResponseInterceptor } from './interceptors/http-client-response.interceptor';

@NgModule({
    imports: [
        HttpClientNativeModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpClientResponseInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpClientErrorInterceptor,
            multi: true,
        },
    ],
    exports: [
        HttpClientNativeModule,
    ],
})

export class HttpClientModule {
    public static forRoot(environment, OAuthModel): ModuleWithProviders {
        return {
            ngModule: HttpClientModule,
            providers: [
                {
                    provide: 'Env',
                    useValue: environment,
                },
                {
                    provide: 'OAuthModel',
                    useClass: OAuthModel,
                },
            ],
        };
    }
}
